import React from 'react'
import { observer } from 'mobx-react-lite'
import { toast } from 'react-toastify'
import EandOPolicyUploader from './EandOPolicyUploader.component'
import LoadingSpinner from './../../shared/LoadingSpinner.component'
import { MDBRow, MDBBtn, MDBCol, MDBInput } from 'mdbreact'
import { UIInput, UIDatePickerInput } from './../../forms/form-fields'
import moment from 'moment'
import EopolicyStore from './Eopolicy.store'
import AgentProfileStore from './../AgentProfileIntake/AgentProfile.store'

import './EandOForm.component.scss'

const convertDate = (value) => {
  value = value && typeof value === 'string' ? value.split('T')[0] : value

  if (value && typeof value === 'string')
    return moment(value, 'YYYY-MM-DD').toDate()
  if (value && typeof value === 'object') return value
}

const currencyKeypress = (event) => {
  const { Policy } = EopolicyStore

  let name = event.target.name,
    isNumeric = event.which >= 48 && event.which <= 57,
    isDecimal = parseInt(event.which) === 46,
    decimalExists = `${Policy.get(name)}`.indexOf('.') > -1

  if ((isNumeric || isDecimal) && !decimalExists) return true

  if (
    isNumeric &&
    decimalExists &&
    `${Policy.get(name)}`.split('.')[1].length < 2
  )
    return true

  event.preventDefault()
  return false
}

const EandOForm = (props) => {
  const {
    Policy,
    savePolicy,
    showValidity,
    isSaving,
    getIsValid,
    getIsDatesValid,
  } = EopolicyStore

  const isDatesValid = getIsDatesValid(),
    minDate = moment(
      Policy?.get('effective_date') &&
        typeof Policy.get('effective_date') === 'object'
        ? Policy.get('effective_date')
        : new Date()
    )
      .add(1, 'days')
      .toDate(),
    EffectiveDate = React.forwardRef((props, ref) => (
      <MDBInput label="Effective Date" ref={ref} {...props} />
    )),
    ExpiryDate = React.forwardRef((props, ref) => (
      <MDBInput label="Expiration Date" ref={ref} {...props} />
    )),
    effective_date =
      Policy && convertDate(Policy?.get('effective_date'))
        ? moment(convertDate(Policy?.get('effective_date'))).format(
            'MM/DD/YYYY'
          )
        : Policy?.get('effective_date'),
    expiration_date =
      Policy && convertDate(Policy?.get('expiration_date'))
        ? moment(convertDate(Policy?.get('expiration_date'))).format(
            'MM/DD/YYYY'
          )
        : Policy?.get('expiration_date'),
    autoSave = props?.autoSave === true,
    onAutoSave =
      typeof props?.onAutoSave === 'function' ? props?.onAutoSave : () => {},
    isValid =
      Object.values(showValidity).length === 6 &&
      Object.values(showValidity).every((v) => v === false)

  return (
    <form id="EandOFormComponent" className="container-fluid">
      <MDBRow>
        {Policy && !EopolicyStore.isLoading ? (
          <>
            <MDBCol size="12" sm="9">
              <MDBRow>
                <MDBCol size="12" sm="6">
                  <div
                    className={[
                      'input-wrapper input-select-wrapper',
                      !Policy?.get('carrier_name') ? 'active-input' : '',
                    ].join(' ')}
                  >
                    <UIInput
                      label="E&O Policy Carrier"
                      name="carrier_name"
                      value={Policy?.get('carrier_name')}
                      onChange={(event) => {
                        EopolicyStore.Policy.set(
                          'carrier_name',
                          event.target.value
                        )
                        if (!EopolicyStore.Policy.get('carrier_name'))
                          return (EopolicyStore.showValidity.carrier_name = true)
                        EopolicyStore.showValidity.carrier_name = false
                        if (autoSave === true)
                          savePolicy({ debounce: 250 }).finally(() =>
                            onAutoSave(getIsValid())
                          )
                      }}
                      rules={{
                        required: true,
                      }}
                      required
                      showValidity={showValidity?.carrier_name}
                    />
                  </div>
                </MDBCol>
                <MDBCol size="12" sm="6">
                  <div
                    className={[
                      'input-wrapper',
                      !Policy?.get('eopolicy_num') ? 'active-input' : '',
                      !Policy?.id() && !Policy?.get('carrier_name')
                        ? 'disabled-input'
                        : '',
                      Policy?.id() && !Policy?.get('eopolicy_num')
                        ? 'invalid-input'
                        : '',
                    ].join(' ')}
                  >
                    <UIInput
                      label="E&O Policy Number"
                      name="eopolicy_num"
                      disabled={!Policy?.get('carrier_name')}
                      value={Policy?.get('eopolicy_num')}
                      onChange={(event) => {
                        EopolicyStore.Policy.set(
                          'eopolicy_num',
                          event.target.value
                        )
                        if (!EopolicyStore.Policy.get('eopolicy_num'))
                          return (EopolicyStore.showValidity.eopolicy_num = true)
                        EopolicyStore.showValidity.eopolicy_num = false
                        if (autoSave === true)
                          savePolicy({ debounce: 250 }).finally(() =>
                            onAutoSave(getIsValid())
                          )
                      }}
                      rules={{
                        required: true,
                      }}
                      required
                      showValidity={showValidity?.eopolicy_num}
                    />
                  </div>
                </MDBCol>
                <MDBCol size="12" sm="6">
                  <div
                    className={[
                      'input-wrapper',
                      !Policy?.get('per_coverage_amt') ? 'active-input' : '',
                      !Policy?.id() && !Policy?.get('eopolicy_num')
                        ? 'disabled-input'
                        : '',
                      Policy?.id() && !Policy?.get('per_coverage_amt')
                        ? 'invalid-input'
                        : '',
                    ].join(' ')}
                  >
                    <UIInput
                      label="Coverage Amount (each occurrence)"
                      name="per_coverage_amt"
                      disabled={
                        !Policy?.get('carrier_name') ||
                        !Policy?.get('eopolicy_num')
                      }
                      value={Policy?.get('per_coverage_amt')}
                      onChange={(event) => {
                        const value = event.target.value
                        EopolicyStore.Policy.set('per_coverage_amt', value)

                        if (!value || value > 999999999)
                          return (EopolicyStore.showValidity.per_coverage_amt = true)

                        EopolicyStore.showValidity.per_coverage_amt = false
                        if (autoSave === true)
                          savePolicy({ debounce: 250 }).finally(() =>
                            onAutoSave(getIsValid())
                          )
                      }}
                      rules={{
                        required: true,
                        maxValue: 999999999,
                        minValue: 1,
                      }}
                      showValidity={showValidity?.per_coverage_amt}
                      onKeyPress={currencyKeypress}
                      required
                    />
                  </div>
                </MDBCol>
                <MDBCol size="12" sm="6">
                  <div
                    className={[
                      'input-wrapper',
                      !Policy?.get('agg_coverage_amt') ? 'active-input' : '',
                      !Policy?.id() && !Policy?.get('per_coverage_amt')
                        ? 'disabled-input'
                        : '',
                      Policy?.id() && !Policy?.get('agg_coverage_amt')
                        ? 'invalid-input'
                        : '',
                    ].join(' ')}
                  >
                    <UIInput
                      label="Coverage Amount (Aggregate)"
                      name="agg_coverage_amt"
                      disabled={
                        !Policy?.get('carrier_name') ||
                        !Policy?.get('eopolicy_num') ||
                        !Policy?.get('per_coverage_amt')
                      }
                      value={Policy?.get('agg_coverage_amt')}
                      onChange={(event) => {
                        const value = event.target.value
                        EopolicyStore.Policy.set('agg_coverage_amt', value)

                        if (!value || value > 999999999)
                          return (EopolicyStore.showValidity.agg_coverage_amt = true)

                        EopolicyStore.showValidity.agg_coverage_amt = false
                        if (autoSave === true)
                          savePolicy({ debounce: 250 }).finally(() =>
                            onAutoSave(getIsValid())
                          )
                      }}
                      rules={{
                        required: true,
                        maxValue: 999999999,
                        minValue: 1,
                      }}
                      showValidity={showValidity?.agg_coverage_amt}
                      onKeyPress={currencyKeypress}
                      required
                    />
                  </div>
                </MDBCol>
                <MDBCol size="12" sm="6">
                  <div
                    className={[
                      'input-wrapper',
                      Policy?.get('eopolicy_num') &&
                      Policy?.get('carrier_name') &&
                      Policy?.get('per_coverage_amt') &&
                      Policy?.get('agg_coverage_amt') &&
                      !effective_date
                        ? 'active-input'
                        : '',
                      !Policy?.id() && !Policy?.get('agg_coverage_amt')
                        ? 'disabled-input'
                        : '',
                      Policy?.id() && (!effective_date || !isDatesValid)
                        ? 'invalid-input'
                        : '',
                    ].join(' ')}
                  >
                    <UIDatePickerInput
                      showYearDropdown
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown
                      disabled={
                        !Policy?.get('eopolicy_num') ||
                        !Policy?.get('carrier_name') ||
                        !Policy?.get('per_coverage_amt') ||
                        !Policy?.get('agg_coverage_amt')
                      }
                      selected={
                        effective_date
                          ? moment(effective_date, 'MM/DD/YYYY').toDate()
                          : null
                      }
                      dateFormat="MM/dd/yyyy"
                      name="effective_date"
                      onChange={(event) => {
                        const curr = Policy.get('effective_date'),
                          change = event.target.value

                        EopolicyStore.Policy.set('effective_date', change)

                        if (
                          (curr && !change) ||
                          (!curr && change) ||
                          moment(convertDate(curr)).format('MM/DD/YYYY') !==
                            moment(convertDate(change)).format('MM/DD/YYYY')
                        ) {
                          EopolicyStore.showValidity.effective_date = false
                          if (autoSave === true)
                            savePolicy({ debounce: 250 }).finally(() =>
                              onAutoSave(getIsValid())
                            )
                          return true
                        }

                        return (EopolicyStore.showValidity.effective_date = true)
                      }}
                      showValidity={showValidity?.effective_date}
                      rules={{ required: true }}
                      required
                      minDate={minDate}
                      customInput={<EffectiveDate />}
                    />
                    {!isDatesValid ? (
                      <small className="text--red">
                        <strong>
                          Expiration date must occur after Effective date.
                        </strong>
                      </small>
                    ) : (
                      <></>
                    )}
                  </div>
                </MDBCol>
                <MDBCol size="12" sm="6">
                  <div
                    className={[
                      'input-wrapper',
                      !expiration_date ? 'active-input' : '',
                      !Policy?.id() && !Policy?.get('effective_date')
                        ? 'disabled-input'
                        : '',
                      Policy?.id() && (!expiration_date || !isDatesValid)
                        ? 'invalid-input'
                        : '',
                    ].join(' ')}
                  >
                    <UIDatePickerInput
                      showYearDropdown
                      yearDropdownItemNumber={100}
                      scrollableYearDropdown
                      disabled={
                        !Policy?.get('eopolicy_num') ||
                        !Policy?.get('carrier_name') ||
                        !Policy?.get('per_coverage_amt') ||
                        !Policy?.get('agg_coverage_amt') ||
                        !Policy?.get('effective_date')
                      }
                      selected={
                        expiration_date
                          ? moment(expiration_date, 'MM/DD/YYYY').toDate()
                          : null
                      }
                      dateFormat="MM/dd/yyyy"
                      name="expiration_date"
                      onChange={(event) => {
                        const curr = Policy.get('expiration_date'),
                          change = event.target.value

                        EopolicyStore.Policy.set('expiration_date', change)

                        if (
                          (curr && !change) ||
                          (!curr && change) ||
                          moment(convertDate(curr)).format('MM/DD/YYYY') !==
                            moment(convertDate(change)).format('MM/DD/YYYY')
                        ) {
                          EopolicyStore.showValidity.expiration_date = false
                          if (autoSave === true)
                            savePolicy({ debounce: 250 }).finally(() =>
                              onAutoSave(getIsValid())
                            )
                          return true
                        }

                        return (EopolicyStore.showValidity.expiration_date = true)
                      }}
                      showValidity={showValidity?.expiration_date}
                      rules={{ required: true }}
                      required
                      customInput={<ExpiryDate />}
                    />
                  </div>
                </MDBCol>
                {autoSave === true ? (
                  <></>
                ) : (
                  <MDBCol size="12">
                    <MDBBtn
                      size="sm"
                      block
                      color="success"
                      disabled={!isValid || isSaving || EopolicyStore.isLoading}
                      className="submit-btn"
                      onClick={() => {
                        AgentProfileStore.setValidity('eopolicy', getIsValid())
                        savePolicy().then(
                          (msg) =>
                            toast.success(
                              'Great! The E&O policy has been updated.',
                              { position: toast.POSITION.TOP_RIGHT }
                            ),
                          (err) =>
                            toast.error(`${err}`, {
                              position: toast.POSITION.TOP_RIGHT,
                            })
                        )
                      }}
                    >
                      {isSaving ? (
                        <>
                          <i className="fa fa-spin fa-spinner"></i> Saving ...
                        </>
                      ) : (
                        'Save E&O Policy'
                      )}
                    </MDBBtn>
                  </MDBCol>
                )}
              </MDBRow>
            </MDBCol>
            <MDBCol size="12" sm="3">
              <EandOPolicyUploader />
            </MDBCol>
          </>
        ) : (
          <>
            <div className="eo-loading-spinner">
              <LoadingSpinner size="sm" isActive={true} label={'E&O Records'} />
            </div>
          </>
        )}
      </MDBRow>
    </form>
  )
}

export default observer(EandOForm)
